module.exports = __webpack_public_path__ + "img/WhatsApp.792870d3.png";